module.exports = __webpack_public_path__ + "static/media/time_management_small.8d9d9502.jpg";